import { defineMessages } from '@transcend-io/internationalization';

export const policyVersionSliderMessages = defineMessages(
  'privacy-center.components.PolicyVersionSlider.policyVersionSlider',
  {
    current: {
      defaultMessage: 'Current',
    },
  },
);
